import { User } from '@angular/fire/auth';

export class SetUserAction {
  public static readonly type = '[Authentication] SetUserAction';
  constructor(public readonly user: User | null) {}
}
